import { DefaultTheme } from 'styled-components';

import { typographyScaleDesktop, typographyScaleMobile } from './typographyScale';
import { Breakpoints } from './styled';

export const typographyScale = {
  desktop: typographyScaleDesktop,
  mobile: typographyScaleMobile,
};

const breakpoints: Breakpoints = ['600px', '900px', '1200px'];

breakpoints.sm = breakpoints[0];
breakpoints.md = breakpoints[1];
breakpoints.lg = breakpoints[2];

/*up: (breakpoint) => `@media (min-width: calc(${breakpoint} + 0.02px))`,
down: (breakpoint) => `@media (max-width: ${breakpoint})`*/

const mediaQueries = {
  sm: `@media (max-width: ${breakpoints[0]})`,
  md: `@media (max-width: ${breakpoints[1]})`,
  lg: `@media (min-width: calc(${breakpoints[1]} + 0.02px) and max-width: ${breakpoints[2]})`,
  xl: `@media (min-width: calc(${breakpoints[2]} + 0.02px))`,
};

// eslint-disable-next-line
const space = [
  0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68, 72, 76, 80, 84, 88, 92, 96,
  100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140,
];

export type ThemeType = 'light' | 'dark';

const LightTheme: DefaultTheme = {
  rtl: false,
  colors: {
    palette: {
      white: '#FFFFFF',
      black: '#000000',
      primary: '#3FD600',
      primaryHover: '#86E034',
      brand: 'linear-gradient(90deg, #DFF60D 0%, #3FD600 100%)',
      brandHover: 'linear-gradient(90deg, #DFF60D 20%, #3FD600 100%)',
      green: '#2FBE64',
      lightOrDarkGreen: '#EBFCF4',
      red: '#E73E6B',
      lightOrDarkRed: '#FFEBED',
      orange: '#FFAF12',
      lightOrDarkOrange: '#FEF7EA',
      blue: '#4282FF',
      lightOrDarkBlue: '#E6EFFA',
      purple: '#8742FF',
      lightOrDarkPurple: '#E6E6FA',
    },
    background: {
      main: '#FFFFFF',
      inverse: '#000000',
      secondary: {
        BG1: '#FFFFFF',
        BG2: '#FFFFFF',
        BG3: '#F6F6F6',
        BG4: '#EAEAEA',
      },
    },
    border: {
      lighter: '#EBEBEB',
      middle: '#BBBBBB',
      darker: '#000000',
    },
    overlay: {
      1: '#FFFFFF',
      2: '#FFFFFF',
      3: '#F6F6F6',
      4: '#EAEAEA',
    },
    text: {
      primary: '#000000',
      secondary: '#4D4A46',
      tertiary: '#999999',
      disabled: '#D6D6D6',
      inverse: '#FFFFFF',
    },
  },
  breakpoints,
  space,
  mediaQueries,
  typographyScale,
};
const DarkTheme: DefaultTheme = {
  rtl: false,
  colors: {
    palette: {
      white: '#FFFFFF',
      black: '#000000',
      primary: '#DFF60D',
      primaryHover: '#E2EF3C',
      brand: 'linear-gradient(90deg, #DFF60D 0%, #3FD600 100%)',
      brandHover: 'linear-gradient(90deg, #DFF60D 20%, #3FD600 100%)',
      green: '#2FBE64',
      lightOrDarkGreen: '#16241F',
      red: '#E73E6B',
      lightOrDarkRed: '#28191B',
      orange: '#FFAF12',
      lightOrDarkOrange: '#352C22',
      blue: '#4282FF',
      lightOrDarkBlue: '#172B41',
      purple: '#8742FF',
      lightOrDarkPurple: '#1F1D38',
    },
    background: {
      main: '#050505',
      inverse: '#FFFFFF',
      secondary: {
        BG1: '#050505',
        BG2: '#141517',
        BG3: '#1B1C1F',
        BG4: '#26282C',
      },
    },
    border: {
      lighter: '#2A2E39',
      middle: '#404040',
      darker: '#FFFFFF',
    },
    overlay: {
      1: '#050505',
      2: '#141517',
      3: '#1B1C1F',
      4: '#26282C',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#AAAAAA',
      tertiary: '#777777',
      disabled: '#333333',
      inverse: '#000000',
    },
  },
  breakpoints,
  space,
  mediaQueries,
  typographyScale,
};

export { LightTheme, DarkTheme, breakpoints, space };
